import type { FC } from "react";
import type { DirectorySummaryList as DirectorySummaryListProps } from "@motain/xpa-proto-files-web/lib/types/directory_summary_list";
import Link from "next/link";
import styles from "./DirectorySummaryList.module.scss";
import classnames from "classnames";

export const DirectorySummaryList: FC<DirectorySummaryListProps> = (props) => {
  const { titleVisible, titleA11y, links, groupLink } = props;

  return (
    <nav aria-label={titleA11y} className={styles.container}>
      <header className="title-7-bold">{titleVisible}</header>
      <ul className={styles.links}>
        {links.map((link) => (
          <li key={link.name}>
            <Link
              href={link.urlPath}
              className={classnames("title-7-regular", styles.link)}
            >
              <span className={styles.linkText}>{link.name}</span>
            </Link>
          </li>
        ))}

        {groupLink && (
          <li className={styles.groupLinkContainer}>
            <Link href={groupLink.urlPath} className={styles.groupLink}>
              <span
                className={classnames("title-7-regular", styles.groupLinkText)}
              >
                {groupLink.name}
              </span>
              <svg
                fill="none"
                viewBox="0 0 24 25"
                className={styles.groupLinkArrow}
              >
                <path
                  d="M10 8.5l3.69 4-3.69 4"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                ></path>
              </svg>
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
};
